<template>
  <div>
    <v-btn
      class="mx-2"
      fab
      dark
      large
      elevation="0"
      color="primary"
      @click.stop="showHelp"
      id="help-button"
    >
      <v-icon dark x-large> mdi-help-circle-outline </v-icon>
    </v-btn>
    <v-dialog max-width="500" v-model="dialog">
      <v-card color="blue lighten-3">
        <v-card-title class="text-h6 blue lighten-2">
          Aide Euro-Pharmat <br v-if="titre" />
          {{ titre }}
        </v-card-title>
        <v-card-text>
          <p
            class="mb-0 font-weight-bold"
            :class="index == 0 ? 'mt-4' : ''"
            v-for="(par, index) in pars"
            :key="index"
          >
            {{ par }}
          </p>
          <ul class="mt-2" v-if="listItems">
            <li v-for="(item, index) in listItems" :key="index">
              <span v-html="traiteSpans(item)"></span>
            </li>
          </ul>
          <p
            class="mb-0 font-weight-bold"
            :class="index == 0 ? 'mt-4' : ''"
            v-for="(par, index) in pars2"
            :key="index"
          >
            {{ par }}
          </p>
          <p class="mt-4 text-center font-weight-bold">{{ conclusion }}</p>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import AideService from "@/services/AideService";

export default {
  data() {
    return {
      dialog: false,
      pars: null,
      pars2: null,
      listItems: null,
      titre: "",
      conclusion: "",
    };
  },
  methods: {
    showHelp() {
      this.texte = "";
      this.dialog = true;
      const typeRecherche = this.getTypeAide(this.$store.state.recherche.type);
      AideService.getAide(typeRecherche).then((res) => {
        this.traiteAide(res.data.texte);
      });
    },

    getTypeAide(typeRecherche) {
      switch (this.$route.name) {
        case "home": //Accueil
          return 14;
        case "deno-commune": // Fiche déno
          return 17;
        case "fournisseur": // Fiche fournisseur
          return 18;
        case "produit": //Fiche produit
          return 20;
        case "multiCriteres": // Recherche multi-critères
          return 11;
        // TODO: réformer la suite pour continuer à se base sur les routes!
        case "denos-communes": // Liste des dénos
          return 16;
        case "fournisseurs": // Liste des fournisseurs
          return 19;
        case "produits": // Liste des produits
        case "multiCriteresListe": // Liste des produits post-recherche MC
          return 21;
        case "fournisseurs-deno-commune": // Liste Frns/Pdts d'une déno
          return 21;
        case "produits-deno-commune": // Liste Pdts/Frns d'une déno
          return 21;
        case "denos-communes-fournisseur": // Liste Denos/Pdts d'un frn
          return 21;
        case "produits-fournisseur": // Liste Denos/Pdts d'un frn
          return 21;
        default:
          switch (typeRecherche) {
            case 1: // Liste des dénos
              return 16;
            case 2: // Liste des fournisseurs
              return 19;
            case 3: // Liste des produits
              return 21;
            case 4: // Liste Frns/Pdts d'une déno
              return 21;
            case 5: // Liste Pdts/Frns d'une déno
              return 21;
            case 6: // Liste Denos/Pdts d'un frn
              return 21;
          }
      }
    },
    traiteAide(texte) {
      let lignes = texte.split("\r\n");
      let pars = [];
      let pars2 = [];
      let listItems = [];
      this.pars = [];
      this.listItems = [];
      this.titre = lignes.shift();
      this.conclusion = lignes.pop();
      lignes.forEach((ligne) => {
        if (ligne.substring(0, 2) == "p-") {
          pars.push(ligne.substring(2));
        } else if (ligne.substring(0, 3) == "li-") {
          listItems.push(ligne.substring(3));
        } else if (ligne.substring(0, 3) == "p2-") {
          pars2.push(ligne.substring(3));
        }
      });
      this.pars = pars;
      this.pars2 = pars2;
      this.listItems = listItems;
    },
    traiteSpans(val) {
      return val
        .replace("--red--", '<span style="color:red">')
        .replace("--/red--", "</span>")
        .replace("--cox--", '<img src="/img/cox.png" style="height:1em">')
        .replace("--/cox--", "</img>")
        .replace("--e--", "<sup>")
        .replace("--/e--", "</sup>");
    },
  },
};
</script>

<style>
#help-button {
  position: absolute;
  top: 108px;
  right: 20px;
  z-index: 10;
}
#help-button:focus::before {
  opacity: 0 !important;
}
.v-card__title {
  word-break: normal !important;
}
</style>
